import { categorizeDifficulty, toCamelCase } from './stringUtils';

export const applyFilters = (rows, filters) => {
  // Early return if no filters are active
  if (!Object.values(filters).some(f => Array.isArray(f) && f.length > 0)) {
    return rows;
  }

  // Pre-calculate days of week if day filter is active
  let rowDays;
  if (filters.dayOfWeek?.length > 0) {
    rowDays = new Map(rows.map(row => [
      row,
      new Date(row.startDate).toLocaleDateString('en-US', { weekday: 'long' })
    ]));
  }

  return rows.filter((row) => {
    // Check venue search filter first
    if (filters.venueSearch?.length > 0 && !filters.venueSearch.includes(row.venue)) return false;
    
    // Check simple filters next for early return
    // Apply toCamelCase to row.groupName for consistent comparison
    if (filters.group?.length > 0 && !filters.group.includes(toCamelCase(row.groupName))) return false;
    if (filters.location?.length > 0 && !filters.location.includes(row.venue)) return false;
    if (filters.dates?.length > 0 && !filters.dates.includes(row.startDate)) return false;

    // Handle availability with early return
    if (filters.availability?.length > 0) {
      const hasWaitlist = row.waitlistUserCount > 0;
      const hasSlots = parseInt(row.freeSlots, 10) > 0;
      const availabilityMatch = 
        (filters.availability.includes('Has Waitlist') && hasWaitlist) ||
        (filters.availability.includes('No waitlist') && !hasWaitlist && hasSlots);
      if (!availabilityMatch) return false;
    }

    // Use cached day of week
    if (filters.dayOfWeek?.length > 0) {
      if (!filters.dayOfWeek.includes(rowDays.get(row))) return false;
    }

    // Check difficulty last as it's the most complex
    if (filters.difficulty?.length > 0) {
      if (!categorizeDifficulty(row.difficulty || '').some(
        category => filters.difficulty.includes(category)
      )) return false;
    }

    return true;
  });
};
